"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function percentToByte(p) {
    return String.fromCharCode(parseInt(p.slice(1), 16));
}
function encode(str) {
    return btoa(encodeURIComponent(str).replace(/%[0-9A-F]{2}/g, percentToByte));
}
exports.encode = encode;
function byteToPercent(b) {
    return `%${`00${b.charCodeAt(0).toString(16)}`.slice(-2)}`;
}
function decode(str) {
    return decodeURIComponent(Array.from(atob(str), byteToPercent).join(""));
}
exports.decode = decode;
//# sourceMappingURL=browser.js.map